import React, { useEffect, useState } from "react";
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import './Footer.css'; // Make sure this imports the CSS

export default function ScrollToTop() {
    const [isVisible, setIsVisible] = useState(false);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    useEffect(() => {
        const toggleVisibility = () => {
            if (window.pageYOffset > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener("scroll", toggleVisibility);
        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    return (
        <div 
            onClick={scrollToTop} 
            className="scroll-to-top"
            role="button"
            tabIndex={0}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); scrollToTop(); } }}
            style={{ 
                opacity: isVisible ? 1 : 0, 
                visibility: isVisible ? 'visible' : 'hidden',
                transition: 'opacity 0.3s ease, visibility 0.3s ease'
            }}
            aria-label="Scroll to top"
        >
            <ExpandLessIcon className="arrow-icon" />
        </div>
    );
}